import '../styles/HomeTeamSlider.scss';
import 'swiper/css';
import 'swiper/css/free-mode';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NodeServer, TeamCollectionName } from '../config';
import axios from 'axios';
import { useInView } from 'react-intersection-observer';

interface TeamItem {
  nftId: number;
  image: string;
  name: string;
  occupationName: string;
}

export const HomeTeamSlider = () => {
  const [loading, setLoading] = useState(true);
  const [teamCards, setTeamCards] = useState([] as TeamItem[]);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const getTeam = async () => {
      const response = await axios.get<any>(
        `${NodeServer.baseURL}${NodeServer.teamGallery}${TeamCollectionName}`,
        { withCredentials: true }
      );

      // TODO: used for local debug and develop
      // const response = {
      //     data: [
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/0.png",
      //             "name": "Anna Sher",
      //             "occupationName": "Immersive Entrepreneur",
      //             "nftId": 0
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/1.png",
      //             "name": "Den Nich",
      //             "occupationName": "Creative Director",
      //             "nftId": 1
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/2.png",
      //             "name": "Igrek",
      //             "occupationName": "Metaverse Cringineer",
      //             "nftId": 2
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/3.png",
      //             "name": "Liza Nest",
      //             "occupationName": "Volumetric Creator",
      //             "nftId": 3
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/4.png",
      //             "name": "Igor Merch",
      //             "occupationName": "Application Face Sculptor",
      //             "nftId": 4
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/5.png",
      //             "name": "Olha Teren",
      //             "occupationName": "Metaverse Guide",
      //             "nftId": 5
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/6.png",
      //             "name": "Dmitro Lev",
      //             "occupationName": "Metaverse Voodoo Master",
      //             "nftId": 6
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/7.png",
      //             "name": "0xWysocki",
      //             "occupationName": "Machine Brain Engineer",
      //             "nftId": 7
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/8.png",
      //             "name": "Fabler",
      //             "occupationName": "Digitalizer",
      //             "nftId": 8
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/9.png",
      //             "name": "Rom Bur",
      //             "occupationName": "Cloud Guard",
      //             "nftId": 9
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/10.png",
      //             "name": "Oleg Dem",
      //             "occupationName": "Multidimensional Implementor",
      //             "nftId": 10
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/11.png",
      //             "name": "7a",
      //             "occupationName": "Psychokinetic Dreamer",
      //             "nftId": 11
      //         },
      //         {
      //             "image": "https://fortuneTeller.softserveinc.com/blob/images/57.png",
      //             "name": "Mr3ddi",
      //             "occupationName": "Error Detective",
      //             "nftId": 57
      //         }
      //     ]
      // }
      const cardsArr = response?.data as TeamItem[];
      if (cardsArr) {
        const sortedTeam = cardsArr.sort((a, b) =>
          a.nftId > b.nftId ? 1 : -1
        );
        setTeamCards(sortedTeam);
      }
      setLoading(false);
    };
    try {
      getTeam();
    } catch (error) {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <div
        ref={ref}
        className={
          inView
            ? 'home-team-slider-section slideInUp'
            : 'home-team-slider-section'
        }
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <div className="home-team-slider-wrapper">
          <h2 className="block-title">Learn more about Alnair’s creation</h2>
        </div>
      </div>
      <div className="slider-wrapper">
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
    </>
  );
};
